import { Theme } from "@mui/material";

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: 'absolute',
      maxWidth: "85%",
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    modalHeading:{
      fontWeight:700,
      fontSize:"22px",
      color:"#475467",
      marginBottom:"10px"
    },
    main:{
      "& .shipeezi-new-grid-component":{
        "& > :nth-child(1)": {   
          "& > :nth-child(1)": {  // Assuming .makeStyles-leftSide-406 is the first child
           width:"unset"  
          },
        },
      }
    }
  }),
);
export default useStyles